import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Shield, Zap, Clock } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center pt-20 pb-16 overflow-hidden" data-id="element-70">
      {/* Background Image with Gradients */}
      <div className="absolute inset-0 z-0" data-id="element-71">
        <div className="absolute inset-0 bg-brand-dark/90 md:bg-brand-dark/70 z-10" data-id="element-72"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-brand-dark via-brand-dark/95 to-transparent z-10 w-full md:w-3/4" data-id="element-73"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-brand-dark via-transparent to-transparent z-10 h-full" data-id="element-74"></div>
        <img src="https://cdn.magicpatterns.com/uploads/wXLpstQWxZ5Yb5VmB3iia1/Opcion_1.png" alt="Hombre revisando puntaje de crédito" className="w-full h-full object-cover object-right md:object-center opacity-60 md:opacity-100" data-id="element-75" />
      </div>

      <div className="container mx-auto px-4 relative z-20" data-id="element-76">
        <div className="max-w-3xl" data-id="element-77">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} data-id="element-78">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-green/10 border border-brand-green/30 text-brand-green text-sm font-semibold mb-6" data-id="element-79">
              <Zap className="w-4 h-4" data-id="element-80" />
              <span data-id="element-81">SISTEMA ACTUALIZADO 2026</span>
            </div>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-display leading-[1.1] mb-6 text-white uppercase" data-id="element-82">
              Recupera tu Crédito en 30 Días:{' '}
              <span className="text-brand-green text-glow block mt-2" data-id="element-83">
                El Sistema Maestro para el Hombre Hispano en USA
              </span>
            </h1>

            <p className="text-xl md:text-2xl text-gray-300 mb-10 leading-relaxed max-w-2xl font-medium" data-id="element-84">
              Limpia tu reporte de crédito sin pagar miles a abogados usando el
              nuevo{' '}
              <span className="text-white font-bold border-b-2 border-brand-green" data-id="element-85">
                "Algoritmo de Disputa"
              </span>{' '}
              que los burós no pueden ignorar.
            </p>

            <CTAButton className="items-start" data-id="element-86" />

            <div className="mt-10 flex flex-wrap items-center gap-6 text-sm text-gray-400 font-medium" data-id="element-87">
              <div className="flex items-center gap-2" data-id="element-88">
                <Shield className="w-5 h-5 text-brand-cyan" data-id="element-89" />
                <span data-id="element-90">Garantía de Ley FCRA</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-91">
                <Clock className="w-5 h-5 text-brand-cyan" data-id="element-92" />
                <span data-id="element-93">Resultados en 30-45 Días</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}